// extracted by mini-css-extract-plugin
module.exports = {"headerMainGrid":"header_headerMainGrid__3DGgo","logoImage":"header_logoImage__1ccwr","role":"header_role__3eQj0"};